<template>
<div class="user-search">
    <el-form ref="searchForm" :model="searchForm" label-width="80px">
        <el-row>
            <el-col :lg="8">
                <el-form-item label="品牌">
                    <el-radio-group v-model="searchForm.brand_id" @change="checkInput">
                        <el-radio :label="1">N牌</el-radio>
                        <el-radio :label="2">S牌</el-radio>
                    </el-radio-group>

                </el-form-item>
            </el-col>
            <el-col :lg="8">
                <el-form-item label="名字:">
                    <el-input v-model="searchForm.name"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="8">
                <el-form-item label="電話:">
                    <el-input v-model="searchForm.phone"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="8">
                <el-form-item label="店櫃:">
                    <el-select v-model="searchForm.shopKey" placeholder="">
                        <el-option v-for="item in shops" :key="item._key" :label="item.name" :value="item._key" clearable>
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="8">
                <el-form-item label="職稱:" label-width="80px">
                    <el-radio-group v-model="searchForm.role">
                        <el-radio :label="1">業務</el-radio>
                        <el-radio :label="2">美容師</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="8">
                <el-button type="primary" @click="fetchUser('searchForm')"> <i class="el-icon-search"></i> 查詢</el-button>
            </el-col>
        </el-row>
    </el-form>
    <el-row type="flex" justify="end">
        <el-col :lg="6">
            <el-button type="primary" @click="addTabs">新增</el-button>
        </el-col>
    </el-row>
    <el-row type="flex" justify="center" tag="main">
        <el-col :lg="22">
            <el-table :data="userItems.slice((currentPage-1)*pagesize,currentPage*pagesize)" empty-text="暫無數據" stripe :header-cell-style="tableHeaderColor">
                <el-table-column prop="name" label="名字"></el-table-column>
                <el-table-column prop="phone" label="電話"></el-table-column>
                <el-table-column prop="role" label="職稱">
                    <template slot-scope="scope">
                        {{scope.row.role == 1 ? '業務' : '美容師'}}
                    </template>
                </el-table-column>
                <el-table-column label="詳細">
                    <template slot-scope="scope">
                        <el-button type="info" icon="el-icon-more" @click="detailTabs(scope.$index, scope.row)" circle></el-button>
                    </template>
                </el-table-column>
                <el-table-column label="狀態" prop="status">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" active-text="開啟" inactive-text="關閉" active-color="#13ce66" inactive-color="#ff4949" @change="updateUserStatus(scope.$index, scope.row)"></el-switch>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next" :total="total1" @current-change="current_change" :header-cell-style="tableHeaderColor">
            </el-pagination>

        </el-col>
    </el-row>

</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import axios from 'axios'
export default {
    name: 'Search',
    data() {
        return {
            userKey: '',
            userItems: [],
            searchForm: {
                name: '',
                brand_id: 1,
                phone: '',
                shopKey: '',
                role: null,

            },

            shops: [],
            pageList: [],
            total1: 0,
            currentPage: 1,
            pagesize: 10,
            bid: {},
            brand_id: null
        }
    },
    computed: mapGetters(["getUser", "getShopList"]),

    methods: {
        ...mapActions(["fetchUser", "updateUserStatus", "fetchShop"]),
        async fetchUser(formName) {
            const data = {
                brand_id: this.searchForm.brand_id,
                shop_key: this.searchForm.shopKey,
                phone: this.searchForm.phone,
                name: this.searchForm.name,
                role: this.searchForm.role

            }
            await this.$store.dispatch('fetchUser', data)

            this.userItems = this.getUser
            this.total1 = this.userItems.length

        },

        updateUserStatus(index, row) {
            let data = {
                _key: row._key,
                status: row.status
            };
            this.$store.dispatch('updateUserStatus', data)
                .then(() => {
                    this.$notify({
                        title: '成功',
                        message: '狀態更改成功',
                        type: 'success'
                    })
                }).catch((err) => {

                });
        },
        addTabs: function () {
            this.$emit('addTabs', this.addUserTabs)
        },
        detailTabs: function (index, row) {
            this.userKey = row._key
            this.$emit('detailTabs', this.userKey)

        },
        async queryShop() {
            if (this.searchForm.brand_id != null) {
                this.bid = {
                    brand_id: this.searchForm.brand_id
                }
            } else {
                this.bid = {}
            }
            await this.$store.dispatch('fetchShop', this.bid)
                .then(() => {
                    this.shops = this.getShopList
                }).catch((err) => {
                    console.log(err);
                });
        },
        checkInput() {
            this.queryShop()
        },
        tableHeaderColor({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (rowIndex === 0) {
                return `background-color: gray;color: #000;`
            }
        },
        current_change: function (currentPage) {
            this.currentPage = currentPage;
        }

    },
    created() {
        this.queryShop()
    },
}
</script>

<style lang="scss" scoped>
.user-search {
    font-weight: bold;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>
